import { Action } from "@ngrx/store/src/models";
import { ReportCategoryModel } from "../../models/ReportCategoryModel";

export const GET_REPORTS_QUERY_SUCCESS = "[SecurityModule] Query Available Permissions Success";

export class GetReportsQuerySuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: ReportCategoryModel[] }) {
    this.type = GET_REPORTS_QUERY_SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/app/report/store/actions/GetReportsQuerySuccessAction.ts